import { useEffect, useState } from "react";
import { kSkillSpike } from "../utils/Constants";
import EventDetailSelector from "./EventDetailSelector";

function EventEditor({
  isPortrait,
  event,
  isCurrentEvent,
  team,
  isDVW,
  narrow,
  onPlayerChanged,
  onSkillChanged,
  onSubskillChanged,
  onAttackCombosChanged,
  onTypeChanged,
  onGradeChanged,
  onExtCode1Changed,
  onExtCode2Changed,
  onExtCode3Changed,
  onSetterCallsChanged,
  setterCalls,
}) {
  const [players, setPlayers] = useState([]);
  const [sortedAttackCombos, setSortedAttackCombos] = useState([]);
  const [useDVAnnotations, setUseDVAnnotations] = useState(true);
  // Setter Call detection must work across both callers of this shared
  // component: DVMatchCoding.jsx (its own internal skill/EventType mapping —
  // typed-code events use EventType 3 + skill char "E" + EventString
  // "Setter Call " (singular), while imported/legacy events use EventType 20)
  // and CodingPage.jsx (standard DataVolley numbering, `kSkillSettersCall`
  // = EventType 20, `skill` is a NUMBER there so it can never equal "E").
  const isSetterCallEvent =
    event?.EventType === 20 ||
    event?.EventType === 3 ||
    event?.skill === "E" ||
    (event?.EventString ?? "").trim().toLowerCase().startsWith("setter call") ||
    (event?.setterCall != null && String(event.setterCall).trim() !== "") ||
    (event?.settersCall != null && String(event.settersCall).trim() !== "");
  const selectedSkillItem = isSetterCallEvent ? 2 : Math.max(0, (event?.EventType ?? 1) - 1);
  // const skills = [
  //   "Serve",
  //   "Pass",
  //   "Set",
  //   "Attack",
  //   "Block",
  //   "Dig",
  //   "Freeball",
  //   "Cover",
  // ];
  const skills = useDVAnnotations
    ? ["S", "R", "E", "A", "B", "D", "F", "C"]
    : ["SER", "REC", "SET", "ATT", "BLK", "DIG", "FRB", "COV"];

  const dvgrades = ["=", "/", "!", "-", "+", "#"];
  // var gr1 = ["Error", "S1", "S2", "Ace", "S3", "Speed"];
  // var gr1err = ["", "Net", "Out Long", "Out Side"];
  // var gr2 = ["Error", "P1", "P2", "P3"];
  // var gr3 = ["Error", "", "Set Assist", ""];
  // var gr4 = ["Error", "In Play", "In Play", "Kill"];
  // var gr4err = ["", "Out", "Blocked", "Net", "Net Touch"];
  // var gr5 = ["Error", "Control", "Solo", "Block Assist"];
  // var gr6 = ["BHE", "Dig", "Dig 2", "Dig 3"];
  // var hr = ["", "Off-speed", "Dump", "Power", "Off-Block"];
  // var sr = ["", "Jump", "Jump-Float", "Float", "Topspin"];
  // var settypes = ["", "1", "2", "3", "4", "5"];

  const subskills = [
    [],
    ["Jump", "Jump-Float", "Float", "Topspin"],
    ["NA", "Left", "Midline", "Right"],
    ["Jump", "Standing", "Running"],
    ["Off-speed", "Dump", "Power", "Off-Block"],
    ["Control", "Solo", "Block Assist"],
    [],
    [],
    [],
  ];
  const grades = [
    [],
    ["=", "/", "!", "-", "+", "#"],
    ["=", "/", "!", "-", "+", "#"],
    ["=", "/", "!", "-", "+", "#"],
    ["=", "/", "!", "-", "+", "#"],
    ["=", "/", "!", "-", "+", "#"],
    ["=", "/", "!", "-", "+", "#"],
    ["=", "/", "!", "-", "+", "#"],
    ["=", "/", "!", "-", "+", "#"],
    ["=", "/", "!", "-", "+", "#"],
  ];
  const attackcombos = [
    " ~",
    "V5",
    "V6",
    "V8",
    "VP",
    "V0",
    "VB",
    "VR",
    "XO",
    "XQ",
    "XS",
    "X9",
    "XT",
    "X3",
    "X4",
    "XP",
    "X0",
    "XB",
    "XR",
    "X5",
    "X6",
    "X8",
    "X1",
    "X7",
    "X2",
    "XM",
    "XG",
    "XC",
    "XD",
    "XL",
    "CB",
    "CF",
    "CS",
    "PP",
  ];

  const defaultSetterCallItems = ["K1", "K2", "K7", "KC", "KM", "KP", "KE", "KD", "KO"];

  const typeOfHitOptions = ["~", "H", "M", "Q", "T", "U", "F", "O"];
  // DataVolley type codes per skill (used for DVW based matches)
  const dvTypeOptions = {
    1: ["~", "H", "M", "Q", "T"], // Serve
    2: ["~", "H", "M", "Q", "T"], // Reception
    5: ["~", "H", "M", "Q", "T", "U", "F", "O"], // Block
  };
  const extCode1Options = ["~", "H", "P", "T"];
  const extCode2Options = ["~", "0", "1", "2", "3", "4"];
  const extCode3Options = ["~", "C", "N", "S", "O", "F", "X"];

  // const getOutcomeIndex = (outcome) => {
  //   const serveoutcomes = [
  //     kServeIn,
  //     kServeFootfault,
  //     kServeAce,
  //     kServeWinner,
  //     kServeLet,
  //     kServeOut,
  //   ];
  //   const returnoutcomes = [
  //     kReturnIn,
  //     kReturnUnforcedError,
  //     kReturnForcingError,
  //     kReturnWinner,
  //   ];
  //   const rallyoutcomes = [
  //     kRallyOutcomeIn,
  //     kRallyOutcomeWinner,
  //     kRallyOutcomeUnforcedError,
  //     kRallyOutcomeForcingError,
  //     kRallyOutcomePassingShot,
  //     kRallyOutcomeOutPassingShot,
  //     kRallyOutcomeNetted,
  //     kRallyOutcomePutAway,
  //   ];

  //   if (event.skill === 0) {
  //     const idx = serveoutcomes.indexOf(outcome);
  //     return idx;
  //   } else if (event.skill === 1) {
  //     const idx = returnoutcomes.indexOf(outcome);
  //     return idx;
  //   } else if (event.skill === 2 || event.skill === 3) {
  //     const idx = rallyoutcomes.indexOf(outcome);
  //     return idx;
  //   }
  //   return 0;
  // };

  const doPlayerChanged = (selitem) => {
    const player = team.players.filter(
      (pl) => pl.shirtNumber.toString() === players[selitem]
    );
    onPlayerChanged({
      FirstName: player[0].FirstName,
      LastName: player[0].LastName,
      ShirtNumber: player[0].shirtNumber,
    });
  };

  const doSkillChanged = (selitem) => {
    const nextEventType = selitem === 2 && isSetterCallEvent ? 20 : selitem + 1;
    event.EventType = nextEventType;
    onSkillChanged(nextEventType);
  };

  const doSubskillChanged = (selitem) => {
    event.SubEvent = selitem;
    onSubskillChanged(selitem);
  };

  const doAttackCombosChanged = (selitem) => {
    event.attackCombo = sortedAttackCombos[selitem];
    onAttackCombosChanged(sortedAttackCombos[selitem]);
  };

  const doTypeOfHitChanged = (selitem) => {
    const val = typeOfHitOptions[selitem];
    event.type = val === "~" ? null : val;
    if (onTypeChanged) onTypeChanged(event.type);
  };

  const doDVTypeChanged = (options, selitem) => {
    const val = options[selitem];
    event.type = val === "~" ? null : val;
    if (onTypeChanged) onTypeChanged(event.type);
  };

  const doExtCode1Changed = (selitem) => {
    event.ExtraCode1 = extCode1Options[selitem];
    if (onExtCode1Changed) onExtCode1Changed(extCode1Options[selitem]);
  };

  const doExtCode2Changed = (selitem) => {
    event.ExtraCode2 = extCode2Options[selitem];
    if (onExtCode2Changed) onExtCode2Changed(extCode2Options[selitem]);
  };

  const doExtCode3Changed = (selitem) => {
    event.ExtraCode3 = extCode3Options[selitem];
    if (onExtCode3Changed) onExtCode3Changed(extCode3Options[selitem]);
  };

  const doGradeChanged = (selitem) => {
    event.EventGrade = selitem;
    onGradeChanged(selitem);
  };

  // Setter calls are match-specific (parsed from the imported .dvw file's
  // [3SETTERCALL] section, or entered manually), so — unlike attack combos —
  // their code/name options come from the `setterCalls` prop rather than a
  // fixed list. Fall back to `defaultSetterCallItems` when the match has no
  // setter calls defined (e.g. no .dvw import, or an empty [3SETTERCALL]
  // section), so the picker still offers a usable set of options. "~~" is
  // always the first option, representing "no setter call" (same convention
  // as the "~" placeholder used by the type-of-hit/ext-code selectors).
  const setterCallItems = [
    "~~",
    ...(setterCalls && setterCalls.length > 0
      ? setterCalls.map((sc) => sc?.code ?? sc?.name ?? "")
      : defaultSetterCallItems),
  ];
  const currentSetterCall = event?.setterCall ?? event?.settersCall ?? "";

  const doSetterCallsChanged = (selitem) => {
    const picked = setterCallItems[selitem] ?? "";
    const call = picked === "~~" ? "" : picked;
    event.setterCall = call;
    event.settersCall = call;
    if (onSetterCallsChanged) onSetterCallsChanged(call);
  };

  const selectedPlayerShirt =
    event?.player?.ShirtNumber != null
      ? String(event.player.ShirtNumber)
      : event?.shirtNumber !== null && event?.shirtNumber !== "-1"
      ? String(event.shirtNumber)
      : "";

  const playerName = (player) => {
    const initial = player.FirstName
      ? player.FirstName.length === 0
        ? ""
        : player.FirstName.substring(0, 1) + "."
      : "";
    const playerLastName =
      player.LastName !== null ? player.LastName.toUpperCase() : "";
    return initial + " " + playerLastName;
  };

  const doInit = () => {
    var pls = [];
    for (var li of team.currentLineup) {
      pls.push(li.playerNumber.toString());
      if (li.subPlayer && pls.includes(li.subPlayer.shirtNumber) === false) {
        pls.push(li.subPlayer.shirtNumber.toString());
      }
    }
    // for (var pl of team.players) {
    //   pls.push(pl.shirtNumber.toString());
    // }
    setPlayers(pls);
    setSortedAttackCombos(attackcombos.sort());
  };

  useEffect(() => {
    if (team) {
      doInit();
    }
  }, [event]);

  if (event === null) {
    return <></>;
  }

  return (
    <>
      <div className="flex-col space-y-1 bg-base-100 rounded-md">
        {/* Player number, Skill and Result (grade) share ONE compact top row in
            landscape; they stack in portrait. */}
        <div
          className={`flex ${isPortrait ? "flex-col" : "flex-row flex-wrap items-start"} gap-1 w-full`}
        >
          <div className={isPortrait ? "w-full" : "flex-1 min-w-0"}>
            <EventDetailSelector
              items={players}
              selectedItem={Math.max(0, players.indexOf(selectedPlayerShirt))}
              onSelectionChanged={(selitem) => doPlayerChanged(selitem)}
            />
          </div>
          <div className={isPortrait ? "w-full" : "flex-1 min-w-0"}>
            <EventDetailSelector
              items={skills}
              selectedItem={selectedSkillItem}
              onSelectionChanged={(selitem) => doSkillChanged(selitem)}
            />
          </div>
          <div className={isPortrait ? "w-full" : "flex-1 min-w-0"}>
            <EventDetailSelector
              items={grades[event.EventType] ?? grades[3]}
              selectedItem={event.EventGrade}
              onSelectionChanged={(selitem) => doGradeChanged(selitem)}
            />
          </div>
        </div>
        {isSetterCallEvent && (
          <div className="w-full">
            <EventDetailSelector
              items={setterCallItems}
              selectedItem={Math.max(0, setterCallItems.indexOf(currentSetterCall))}
              onSelectionChanged={(selitem) => doSetterCallsChanged(selitem)}
            />
          </div>
        )}
        {!(isDVW && event.EventType === kSkillSpike) ? (
          isDVW && dvTypeOptions[event.EventType] ? (
            <div className="w-full">
              <EventDetailSelector
                items={dvTypeOptions[event.EventType]}
                selectedItem={Math.max(
                  0,
                  dvTypeOptions[event.EventType].indexOf(event.type || "~")
                )}
                onSelectionChanged={(selitem) =>
                  doDVTypeChanged(dvTypeOptions[event.EventType], selitem)
                }
              />
            </div>
          ) : (
            <div className="w-full">
              <EventDetailSelector
                items={subskills[event.EventType] ?? []}
                selectedItem={event.SubEvent}
                onSelectionChanged={(selitem) => doSubskillChanged(selitem)}
                // isDisabled={!isCurrentEvent}
              />
            </div>
          )
        ) : null}
        {event.EventType === kSkillSpike ? (
          <>
            <div className="w-full">
              <EventDetailSelector
                items={typeOfHitOptions}
                selectedItem={Math.max(0, typeOfHitOptions.indexOf(event.type || "~"))}
                onSelectionChanged={(selitem) => doTypeOfHitChanged(selitem)}
              />
            </div>
            <div className="flex flex-row flex-wrap gap-1 w-full">
              <div className="flex-1 min-w-0">
                <EventDetailSelector
                  items={extCode1Options}
                  selectedItem={Math.max(0, extCode1Options.indexOf(event.ExtraCode1 || "~"))}
                  onSelectionChanged={(selitem) => doExtCode1Changed(selitem)}
                />
              </div>
              <div className="flex-1 min-w-0">
                <EventDetailSelector
                  items={extCode2Options}
                  selectedItem={Math.max(0, extCode2Options.indexOf(event.ExtraCode2 || "~"))}
                  onSelectionChanged={(selitem) => doExtCode2Changed(selitem)}
                />
              </div>
              <div className="flex-1 min-w-0">
                <EventDetailSelector
                  items={extCode3Options}
                  selectedItem={Math.max(0, extCode3Options.indexOf(event.ExtraCode3 || "~"))}
                  onSelectionChanged={(selitem) => doExtCode3Changed(selitem)}
                />
              </div>
            </div>
            <div className="w-full">
              <EventDetailSelector
                items={sortedAttackCombos}
                selectedItem={sortedAttackCombos.indexOf(event.attackCombo)}
                onSelectionChanged={(selitem) => doAttackCombosChanged(selitem)}
              />
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}

export default EventEditor;
